import { createReducer, on } from '@ngrx/store';
import {
    clearReservation,
    saveReservation,
    updateReservation,
} from './reservation.actions';
import _ from 'lodash';

export const saveReservationReducer = (
    _: any,
    { value }: { value: any },
): any => value;

export const clearReservationReducer = () => {
    return {};
};

export const updateReservationReducer = (
    previus: any,
    { value }: { value: any },
): any => {
    return _.mergeWith({}, previus, value, (objValue, srcValue) => {
        if (Array.isArray(objValue)) {
            return srcValue;
        }
    });
};

export const ReservationReducer = createReducer(
    {},
    on(saveReservation, saveReservationReducer),
    on(updateReservation, updateReservationReducer),
    on(clearReservation, clearReservationReducer),
);
